const en = {
    login: {
      welcome: 'Hi, Welcome Back!',
      signinto: 'Sign in to',
      enterdetail: 'Enter your details below.',
      user: "Email address",
      requireduser: 'Email is required',
      invaliduser: 'Email must be a valid email address',
      password: "Password",
      requiredpassword: 'Password is required',
      remenberme: 'Remenber me',
      forgotpassword: 'Forgot password?',
      login: 'Login' 
    }
  };
  
  export default en;
  